import { refId } from "@suse-o11y/ref-id";
import React from "react";

import { Button } from "~/components/button";
import { For } from "~/components/for";
import { FormField } from "~/components/form/field";
import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";
import { splice } from "~/tools/splice";

import type { FormState } from "./_form-state";
import { Selector } from "./_selector";

export interface SeriesSelectorsProps {
	state: FormState;
}

export const SeriesSelectors: React.FC<SeriesSelectorsProps> = ({ state }) => (
	<FormField className="items-stretch" state={state}>
		<FormLabel asChild>
			<div>
				<FormLabel>Series Selectors</FormLabel>
				<FormFieldReset />
			</div>
		</FormLabel>

		{(monitor, field) => (
			<For className="mb-4 space-y-2" each={field.getElements(monitor)}>
				{(value, index) => (
					<Selector
						key={refId(value)}
						onDelete={() => {
							state.setInput(splice(index, 1, []));
						}}
						state={value}
					/>
				)}
			</For>
		)}

		<Button
			className="uppercase"
			onClick={() => {
				state.setInput((values) => [...values, ""]);
			}}
			variant="primary"
		>
			Add series selector
		</Button>
	</FormField>
);
